import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Confirm, Grid, Segment, SemanticSIZES } from 'semantic-ui-react';
import { PermitFormValues } from '../../../../app/models/permit';
import { useStore } from '../../../../app/stores/store';
import PermitFormStep6FinalReviewLeft from './PermitFormStep6FinalReviewLeft';
import PermitFormStep6FinalReviewRight from './PermitFormStep6FinalReviewRight';
import StepMenu from '../../steps/StepMenu';
import { router } from '../../../../app/router/Routes';

interface Props {
    values: PermitFormValues,
    goTo: (step: number) => void,
    handleFinalFormSubmit: (values: PermitFormValues) => void,
    buttonSize: SemanticSIZES
}

export default observer(function PermitFormStep6FinalReview({ 
    values,
    goTo,
    handleFinalFormSubmit,
    buttonSize
 }: Props) {
    const {userStore, permitStore} = useStore();
    const { user } = userStore;
    const { submitting } = permitStore;
    const [openConfirm, setOpenConfirm] = useState(false);

    useEffect( () => {
        // set step values
        values.isFinalView = true;
    }, [values])

    function handleCancelButton() {
        setOpenConfirm(false);

    }
    function handleOKButton() {
        setOpenConfirm(false);
        
        router.navigate(`${process.env.PUBLIC_URL}`);
    }

    return (
       <>
            <StepMenu currentTab={values.step} position='top' permitTypeId={values.permitTypeId}/>
            
            <Segment attached>
                <Grid>
                    <Grid.Column computer={6} tablet={6} mobile={16}>
                        <PermitFormStep6FinalReviewLeft 
                            values={values} user={user!} goTo={(step: number) => goTo(step)} 
                            buttonSize={buttonSize}
                        />
                    </Grid.Column>
                    <Grid.Column computer={10} tablet={10} mobile={16}>
                        <PermitFormStep6FinalReviewRight values={values} goTo={(step: number) => goTo(step)} />
                    </Grid.Column>
                    <Grid.Column width={16}>
                        <Confirm
                            open={openConfirm}
                            header='Cancel Registration'
                            content='Your permit has not been saved yet. Would you like to delete this permit?'
                            cancelButton='Cancel'
                            confirmButton="Yes"
                            onCancel={handleCancelButton}
                            onConfirm={handleOKButton}
                        />
                        <Button
                            onClick={() => setOpenConfirm(true)}
                            content='Cancel Registration'
                            size={buttonSize}
                            className='cancel-registration-btn'
                        />
                        <Button
                            floated='right'
                            positive
                            disabled={submitting}
                            loading={submitting}
                            onClick={() => handleFinalFormSubmit(values)}
                            type='submit'
                            content='Submit'
                            size={buttonSize}
                            className='final-submit-btn'
                        /> 
                    </Grid.Column>
                </Grid>
            </Segment>
       </>
    )
})